<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/11Em0Fs/tc-custom/9780830894949.jpg?1696024479557" alt="This image is the cover for the book Haggai, Zechariah, Malachi, Tyndale Old Testament Commentaries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Haggai, Zechariah, Malachi, Tyndale Old Testament Commentaries
      </h1>
      <p class="bookDescription body article font2">
        <p>Despite the return of the Hebrews from the Babylonian exile, selfishness, apathy and despair crippled their community spirit. In response to this distress, God raised up three prophetic voices in Jerusalem. Haggai rallied the people to rebuild the Second Temple. Zechariah was given visions of the return of the glory of the Lord to Zion. Malachi preached repentance, covenant justice and restoration of proper temple worship. Andrew Hill's excellent commentary on these oracles shows how they remain timely for the Christian church?s worship and mission in the world.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Andrew E. Hill
      </h2>
      
      <p class="authorDescription body article"><p>Andrew E. Hill is professor of Old Testament at Wheaton College in Wheaton, Illinois. He is the author of commentaries on Malachi (Anchor Bible Commentary) and 1  2 Chronicles (NIVAC), coauthor of <em>A Survey of the Old Testament</em> and the Cornerstone Biblical Commentary on the minor prophets, and coeditor of <em>The Baker Illustrated Bible Commentary</em>.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?73f65d03